import * as devisConf from '@/configuration/devisConf';

export default function lignesNormalesGetter(devisCommande) {
  let lignes = devisCommande.lignesCommande
    .filter(ligne => ligne.type === devisConf.NORMAL);
  devisCommande.lignesCommande
    .filter(ligne => ligne.type === devisConf.REGROUPEMENT)
    .forEach((regroupement) => {
      lignes = lignes.concat(regroupement.lignesCommande
        .filter(ligneR => ligneR.type === devisConf.NORMAL));
    });
  return lignes;
}
